var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFolderSmart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#237BFF",
    d: "M4 4C2.895 4 2 4.895 2 6V18C2 19.105 2.895 20 4 20H11V11H22V8C22 6.895 21.105 6 20 6H12L10 4H4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#237BFF",
    d: "M19 13H18C17.706 13 17.45 13.2 17.379 13.485L17.046 14.815C16.843 14.908 16.65 15.02 16.47 15.149L15.151 14.771C14.868 14.691 14.567 14.813 14.42 15.067L13.92 15.933C13.773 16.188 13.818 16.509 14.029 16.714L15.016 17.667C15.005 17.777 15 17.888 15 18C15 18.112 15.005 18.223 15.016 18.333L14.029 19.286C13.818 19.491 13.773 19.813 13.92 20.067L14.42 20.933C14.567 21.188 14.868 21.309 15.151 21.229L16.47 20.851C16.65 20.98 16.843 21.092 17.046 21.185L17.379 22.515C17.45 22.8 17.706 23 18 23H19C19.294 23 19.55 22.8 19.621 22.515L19.954 21.185C20.157 21.092 20.35 20.98 20.531 20.851L21.85 21.229C22.132 21.309 22.433 21.188 22.58 20.933L23.08 20.067C23.227 19.813 23.182 19.491 22.971 19.286L21.985 18.333C21.995 18.223 22 18.112 22 18C22 17.888 21.995 17.777 21.985 17.667L22.971 16.714C23.182 16.509 23.227 16.188 23.08 15.933L22.58 15.067C22.433 14.813 22.132 14.691 21.85 14.771L20.531 15.149C20.35 15.02 20.157 14.908 19.954 14.815L19.621 13.485C19.55 13.2 19.294 13 19 13ZM18.5 19.5C19.329 19.5 20 18.829 20 18C20 17.172 19.329 16.5 18.5 16.5C17.672 16.5 17 17.172 17 18C17 18.829 17.672 19.5 18.5 19.5Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFolderSmart);
export default __webpack_public_path__ + "static/media/ic_action_folder_smart.339966afdd7270b9e17bc679b47b8a67.svg";
export { ForwardRef as ReactComponent };